import { render, staticRenderFns } from "./LecturesRegions.vue?vue&type=template&id=abf0a980&scoped=true"
import script from "./LecturesRegions.vue?vue&type=script&lang=js"
export * from "./LecturesRegions.vue?vue&type=script&lang=js"
import style0 from "./LecturesRegions.vue?vue&type=style&index=0&id=abf0a980&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abf0a980",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Nevo.SimAdmin.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('abf0a980')) {
      api.createRecord('abf0a980', component.options)
    } else {
      api.reload('abf0a980', component.options)
    }
    module.hot.accept("./LecturesRegions.vue?vue&type=template&id=abf0a980&scoped=true", function () {
      api.rerender('abf0a980', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/LecturesRegions.vue"
export default component.exports